import React, { memo, useEffect, useCallback } from "react";

import { useAxiomState } from "__AxiomComponents/AxiomHooks/AxiomHooks";

import Icon from "../Icons/Icon";
import HawkeyeInsightPortal from "./HawkeyeInsightPortal";
import HawkeyeInsightStory from "../HawkeyeInsightStory/HawkeyeInsightStory";

import "./HawkeyeV2Insights.scss";

function HawkeyeV2Insights(props) {
  const { widget } = props;

  const [state, dispatch] = useAxiomState(
    {
      insights: [],
      isInsightOpen: false,
      selectedStory: null,
    },
    props.appName,
    props.appID,
    "HawkeyeV2Insights",
    props.componentID
  );

  const { insights } = state;

  useEffect(() => dispatch({ subscribeID: widget.subscribeID }, "AxiomEvent", "getInsights"), [
    dispatch,
    widget,
  ]);

  const onStorySelection = useCallback(
    (selectedStory) => {
      if (selectedStory.isActionable) {
        document.body.classList.add("no-scroll");
        dispatch({
          selectedStory,
          isInsightOpen: true,
        });
      }
    },
    [dispatch]
  );

  const closeStorySelection = useCallback(() => {
    document.body.classList.remove("no-scroll");
    dispatch({
      selectedStory: null,
      isInsightOpen: false,
    });
  }, [dispatch]);

  if (insights.length > 0) {
    return (
      <div className="hawkeye-widget-insight-container">
        <div className="hawkeye-widget-insights nice-scroll">
          {insights.map((insight) => (
            <a
              key={insight.id}
              onClick={(e) => onStorySelection(insight)}
              className={`hawkeye-widget-insight ${insight.isActionable && "is-actionable"}`}
            >
              <Icon icon="ICON_INSIGHT" className="hawkeye-widget-insight-icon" />
              <p className="hawkeye-widget-insight-statement">{insight.statement}</p>
            </a>
          ))}
          <HawkeyeInsightPortal>
            {state.isInsightOpen && (
              <div className="hawkeye-story">
                <button
                  onClick={closeStorySelection}
                  className="hawkeye-action hawkeye-story-close"
                >
                  <Icon className="hawkeye-story-close-icon" icon="ICON_CLOSE" />
                </button>
                <HawkeyeInsightStory
                  question={widget.widgetquestion}
                  selectedStory={state.selectedStory}
                  storyList={insights}
                  onStorySelection={onStorySelection}
                  appName={props.appName}
                  appID={props.appID}
                  componentID={props.componentID}
                />
              </div>
            )}
          </HawkeyeInsightPortal>
        </div>
      </div>
    );
  } else {
    return null;
  }
}

export default memo(HawkeyeV2Insights);
